import * as React from 'react';
import { useSelector } from 'react-redux';

import { isNewbuildingConsultBannerAvailable } from '../../../selectors/newbuildingConsultBannerAvailable';
import { NewbuildingConsultTopBannerConatiner } from '../../../serp/components/NewbuildingConsultTopBanner';

export function BannerContainer() {
  const newbuildingConsultBannerAvailable = useSelector(isNewbuildingConsultBannerAvailable);

  if (newbuildingConsultBannerAvailable) {
    return <NewbuildingConsultTopBannerConatiner />;
  }

  return null;
}
